import React from 'react';
import { createRoot } from 'react-dom/client';

// Function che contiene tutta l'applicazione
import App from './App';

// Traduzioni delle varie lingue
import './i18n.js';

// Crea il root per il rendering
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  /*<SSRProvider>*/
  <App />
  /*</SSRProvider>*/
);
